
import React from "react"
import { useNavigate } from 'react-router-dom'
import hotelcss from './css/hotelhotellist.module.css';
import { useEffect } from 'react';
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import { setErrorMessage } from "../tools/errorhandling";
import Dropdown from 'react-multilevel-dropdown';
import { MdEdit, MdDelete } from "react-icons/md";
import {
getverlofaanvragen
} from "../dbconnector/connector";
import Moment from 'moment';
import HolidayRequestNode from '../customNodes/HolidayRequestNode';

const Holidayrequests = (props) => {
    const t = props.translation
    const [requests, setRequests] = useState({});
    const [requestsarray, setRequestsarray] = useState([]);
    const prevCSS = React.useRef(0)
    const prevSelectedRecord = React.useRef(0)
    const [isDisabled, setisDisabled] = useState(false);
    const [selectedRecord, setselectedRecord] = useState([]);
    const [filtervalue, setFiltervalue] = useState("");
    const [filterstatus, setFilterstatus] = useState("");
    var mobile = require('is-mobile');

    useEffect(() => {
        LoadRequests();
        try {
            if (document.getElementById("IconCleaning") !== null)
                document.getElementById("IconCleaning").style.display = "none";
            if (document.getElementById("IconMyData") !== null)
                document.getElementById("IconMyData").style.display = "none";
            if (document.getElementById("IconMyHoliday") !== null)
                document.getElementById("IconMyHoliday").style.display = "block";
            if (document.getElementById("IconMyContract") !== null)
                document.getElementById("IconMyContract").style.display = "none";
        } catch (e) {
            setErrorMessage("Error While retrieving user data")
        }
    }, []);

    const handleCancel = () => {
        document.getElementById("assignmentdetails").style.display = "none"
        document.getElementById("coverAll").style.display = "none"
    }

    useEffect(() => {
        setRequestsarray([])
        try {
            let requestsfiltered = requests;
            if(filtervalue!==""){
                requestsfiltered = requestsfiltered.filter(request=>{
                    const fullname = request.voornaam +" "+ request.achternaam + " "+ request.voornaam
                    if(fullname.toLowerCase().includes(filtervalue.toLowerCase())){
                        return request
                    }
                })
            }
            if(filterstatus!==""){
                requestsfiltered = requestsfiltered.filter(request=>{
                    if(request.status === Number(filterstatus)){
                        return request
                    }
                })
            }
            if (requestsfiltered.length > 0) {
                requestsfiltered.forEach((item, index) => {
                    let cssname = "requested"
                    if (item.status === 0) {
                        cssname = "requested"
                    } else if (item.status === 1) {
                        cssname = "approvedsup"
                    } else if (item.status === 2) {
                        cssname = "approved"
                    }
                    else {
                        cssname = "rejected"
                    }
                    setRequestsarray(pre => [...pre,
                    <div id={item.id} className={index % 2 === 0 ? "linkVarient1Holiday" : "linkVarient2Holiday"} onClick={() => selectRecord(item)} >
                        <p className="gridlabel" style={mobile()? {display:'none'}:{display:'block'}} >{item.id}</p>
                        <p className="gridlabel">{item.achternaam}, {item.voornaam}</p>
                        <p className="gridlabel">{Moment(item.startdatum).format('DD MMM YY')}</p>
                        <p className="gridlabel">{Moment(item.einddatum).format('DD MMM YY')}</p>
                        <p className="gridlabel" style={mobile()? {display:'none'}:{display:'block'}} >{item.reden}</p>
                        <p className={cssname}>{document.getElementById("status" + item.status).innerText}</p>
                    </div>
                    ])
                })
            }
        } catch (error) {
            setErrorMessage(error.message)
        }
    }, [requests,filtervalue,filterstatus]);

    function selectRecord(record) {
        if (record.status > 1 && props.rights === 3 )
        {
            setisDisabled(true);
        }else{setisDisabled(false);}

        if (prevCSS.current !== undefined && prevSelectedRecord.current !== undefined) {
            if (document.getElementById(prevSelectedRecord.current)) {
                document.getElementById(prevSelectedRecord.current).className = prevCSS.current;
            }
        }
        prevCSS.current = document.getElementById(record.id).className;
        prevSelectedRecord.current = record.id
        document.getElementById(record.id).className = "selectedHolidayRow"
        setselectedRecord(record)
        document.getElementById("coverAll").style.display = "block"
        document.getElementById("assignmentdetails").style.display = "block"
    }

    const LoadRequests = () => {
        setRequests([]);
        getverlofaanvragen().then(res => {
            if (res.status === 200) {
                res.json().then(body => {
                    setRequests(body)
                })
            } else {
                setErrorMessage(res.statusText)
            }
        })
    }

    const filterrequest = (e) => {
        setFiltervalue(e.target.value)
    }

    const handleitemchange = (e) => {
        setselectedRecord((prev) => {
            return {
                ...prev,
                [e.target.name]: e.target.value
            }
        })
    }

    const statuschange = (e)=>{
        setFilterstatus(e.target.value)
    }

    return (
        <>
            <div id="main">
                <header>
                    <div id="errordiv" className='error'>
                    </div>
                    <div className="checkinTime">
                        <div id="timelabel" >
                        </div>
                        <div id="time">
                        </div>
                    </div>
                </header>
                <div id="coverAll" className="coverall">
                    <HolidayRequestNode
                        rights={props.rights}
                        t={t}
                        isDisabled={isDisabled}
                        data={{ record: selectedRecord }}
                        events={{ handleCancel: handleCancel,handleitemchange:handleitemchange,LoadRequests:LoadRequests}}
                        css={hotelcss}
                    />
                </div>
                <div id="filters" className="form" >
                    <label className='formtitleContentBox'>
                       {t("filterinstellingen")}
                    </label>
                    <br></br>
                    <div className="contentbox">
                        <div id="searchbox" className="formElement">
                            <label className='labelcolor'>
                                {t("Medewerker")}:
                            </label>
                            <input id="medewerker" onChange={filterrequest} />
                        </div>
                        <div id="searchbox" className="formElement">
                            <label className='labelcolor'>
                                {t("Status")}:
                            </label>
                            <select onChange={statuschange}>
                                <option value="" id="status---">---</option>
                                <option value="0" id="status0">{t('requested')}</option>
                                <option value="1" id="status1">{t('pre-approved')}</option>
                                <option value="2" id="status2">{t('approved')}</option>
                                <option value="3" id="status3">{t('rejected')}</option>
                            </select>
                        </div>
                    </div>
                    <div id="headertable" className="holidayheader">
                        <p id="ID" style={mobile()? {display:'none'}:{display:'block'}} >{t('Id')}</p>
                        <p id="Fullname">{t('Name')}</p>
                        <p id="startdatum">{t('Startdatum')}</p>
                        <p id="einddatum">{t('Einddatum')}</p>
                        <p id="reden" style={mobile()? {display:'none'}:{display:'block'}} >{t('Redenaanvraag')}</p>
                        <p id="status">{t('Status')}</p>
                    </div>
                    <div id="resultlist" className='list'>
                        {requestsarray}
                    </div>
                    <div>

                    </div>
                </div>
            </div>
        </>
    )

}

export default Holidayrequests